<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none">
      <path
        fill="inherit"
        stroke="none"
        d="M14.2 20.08c.46.47 1.06.7 1.8.69.74-.01 1.28-.28 1.63-.8l6.54-9.8-9.8 6.53c-.53.35-.8.89-.83 1.6-.03.72.19 1.32.65 1.78ZM16 6.67a10.75 10.75 0 0 1 6.3 1.92L20.08 10A8.85 8.85 0 0 0 16 9a9 9 0 0 0-6.6 2.73 9 9 0 0 0-2.73 6.6A9.56 9.56 0 0 0 7.95 23h16.1c.45-.74.77-1.5.98-2.3.2-.8.3-1.63.3-2.48a8.39 8.39 0 0 0-.99-3.97l1.4-2.22c.59.92 1.05 1.89 1.39 2.92a11.4 11.4 0 0 1-1.04 9.28c-.21.35-.5.62-.87.81-.37.2-.76.3-1.17.3H7.95c-.4 0-.8-.1-1.17-.3-.37-.2-.66-.46-.87-.81a11.9 11.9 0 0 1-1.58-5.9c0-1.61.31-3.12.92-4.53a11.88 11.88 0 0 1 6.23-6.21c1.42-.62 2.93-.92 4.52-.92Z"
      />
    </svg>
  </span>
</template>
